export const fmtUsd = (n: number) =>
  n.toLocaleString(undefined, { style: "currency", currency: "USD", minimumFractionDigits: 2 });
export const fmtInt = (n: number) => n.toLocaleString();

export const PROVIDER_LABEL: Record<string, string> = {
  lovable_ai: "Default model gateway",
  openrouter_admin: "OpenRouter (admin pool)",
  openrouter_byok: "OpenRouter (workspace BYOK)",
};

export type AiUsageStats = {
  cost_by_provider_30d: Record<string, number>;
  tokens_in_by_provider_30d: Record<string, number>;
  tokens_out_by_provider_30d: Record<string, number>;
  events_by_outcome_30d: Record<string, number>;
  failover_count_30d: number;
  total_events_30d: number;
  daily_admin_spend_30d: Array<{ date: string; cost_usd: number }>;
  admin_spend_this_month_total_usd: number;
  monthly_admin_budget_total_usd: number;
  projected_month_end_admin_spend_usd: number;
  top_admin_funded_workspaces: Array<{
    workspace_id: string;
    workspace_label: string | null;
    account_tier: string | null;
    admin_spend_this_month_usd: number;
  }>;
  top_credit_consumers: Array<{
    owner_user_id: string;
    display_name: string;
    account_tier: string;
    workspace_count: number;
    credits_used_this_month: number;
    topup_balance: number;
  }>;
};
